import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from './Icons';
export const HeroSection = () => {
  return <section id="home" className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden" data-id="element-174">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-175">
        <img src="https://cdn.magicpatterns.com/uploads/kV8aJwdXEDgapbNmfMkYKr/coast1.png" alt="Tree care professional" className="w-full h-full object-cover object-center" data-id="element-176" />
        <div className="absolute inset-0 bg-forest/80 mix-blend-multiply" data-id="element-177"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/50 to-transparent" data-id="element-178"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl" data-id="element-180">
          <div className="inline-block bg-accent/20 backdrop-blur-sm border border-accent/30 text-accent-light px-4 py-1.5 rounded-full text-sm font-bold tracking-wider uppercase mb-6 text-white" data-id="element-181">
            Orange County's Complete Tree Care Specialists
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6" data-id="element-182">
            Expert Tree Care.
            <br data-id="element-183" />
            <span className="text-accent" data-id="element-184">Total Peace of Mind.</span>
          </h1>

          <div className="flex flex-wrap gap-3 mb-10" data-id="element-185">
            {['Palm Trimming', 'Tree Removal', 'Stump Grinding', 'Emergency Service', 'Yard Cleanup'].map((service, idx) => <span key={idx} className="bg-white/10 backdrop-blur-md text-white px-4 py-2 rounded-lg font-medium border border-white/20" data-id="element-186">
                {service}
              </span>)}
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-187">
            <a href="tel:9093717021" className="flex items-center justify-center gap-2 bg-accent hover:bg-[#b56408] text-white px-8 py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105 shadow-xl shadow-accent/30" data-id="element-188">
              <PhoneIcon className="w-6 h-6" data-id="element-189" />
              Get a Free Quote
            </a>
            <a href="#services" className="flex items-center justify-center px-8 py-4 rounded-xl font-bold text-lg text-white bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 transition-all" data-id="element-190">
              See Our Services
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
};